import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "src/environments/environment";

@Pipe({
  name: "currenyFormatter",
})
export class CurrenyFormatterPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (args[0] === "no-fraction") {
      return new Intl.NumberFormat(environment.currencyFormat, {
        minimumFractionDigits: 0,
      }).format(value);
    }
    return new Intl.NumberFormat(environment.currencyFormat, {
      minimumFractionDigits: 2,
    }).format(value);
  }
}
